import { getViewPort } from '@olxeu-a2b/delivery-utils/src/extras/viewPortObserver';
import { USER_ID_COOKIE, getCookie } from '@olxeu-a2b/core/src/utils/cookie';
import { trackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/ninja-utils';

const getPlatformType = () => {
  const { desktop } = getViewPort();
  return desktop ? 'desktop' : 'mobile-html5';
};

export const trackMapViewBack = (eventName: string, touchPointPage: string) => {
  const url = window.location.href.split('/');
  const platformType = getPlatformType();
  const userId = getCookie(USER_ID_COOKIE);
  trackEvent(eventName, null, null, platformType, {
    ad_id: url?.length > 2 ? url[url.length - 2] : null,
    user_id: userId,
    touch_point_page: touchPointPage,
  });
};

export default { trackMapViewBack };
